import { render } from "./BetaPage.vue?vue&type=template&id=2d80972c&scoped=true"
import script from "./BetaPage.vue?vue&type=script&lang=js"
export * from "./BetaPage.vue?vue&type=script&lang=js"

import "./BetaPage.vue?vue&type=style&index=0&id=2d80972c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d80972c"]])

export default __exports__